import React from 'react';

// TypeScript interface for the vending machine data
interface VendingMachine {
  id: number;
  photo: string;
  description: string;
  machineType: string;
  location: {
    address: string;
    city: string;
    state: string;
    zip: string;
  };
}

// Data for 20 vending machines
const vendingMachines: VendingMachine[] = [
  {
    id: 1,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Snack+Machine",
    description: "A classic snack machine filled with chips, cookies, and candy bars.",
    machineType: "Snack Machine",
    location: {
      address: "123 Technology Drive",
      city: "San Francisco",
      state: "CA",
      zip: "94105"
    },
  },
  {
    id: 2,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Beverage+Machine",
    description: "Cold drinks including soda, juice, and bottled water.",
    machineType: "Beverage Machine",
    location: {
      address: "200 Main Street",
      city: "New York",
      state: "NY",
      zip: "10001"
    },
  },
  {
    id: 3,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Coffee+Machine",
    description: "Freshly brewed coffee, espresso, and cappuccino options.",
    machineType: "Coffee Machine",
    location: {
      address: "789 University Way",
      city: "Boston",
      state: "MA",
      zip: "02116"
    },
  },
  {
    id: 4,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Healthy+Snacks",
    description: "A machine specializing in healthy snacks like nuts, granola bars, and fruit.",
    machineType: "Healthy Snack Machine",
    location: {
      address: "101 Wellness Blvd",
      city: "Austin",
      state: "TX",
      zip: "78701"
    },
  },
  {
    id: 5,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Cold+Food",
    description: "A refrigerated machine with sandwiches, salads, and yogurts.",
    machineType: "Cold Food Machine",
    location: {
      address: "456 Office Park",
      city: "Seattle",
      state: "WA",
      zip: "98101"
    },
  },
  {
    id: 6,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Ice+Cream",
    description: "Offers a variety of ice cream bars and frozen treats.",
    machineType: "Ice Cream Machine",
    location: {
      address: "555 Beach Road",
      city: "Miami",
      state: "FL",
      zip: "33101"
    },
  },
  {
    id: 7,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Electronics",
    description: "Small electronics like headphones, chargers, and batteries.",
    machineType: "Electronics Vending Machine",
    location: {
      address: "999 Tech Plaza",
      city: "Palo Alto",
      state: "CA",
      zip: "94301"
    },
  },
  {
    id: 8,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Fresh+Juice",
    description: "A machine that squeezes fresh orange juice on demand.",
    machineType: "Fresh Juice Vending Machine",
    location: {
      address: "222 Farm Road",
      city: "Denver",
      state: "CO",
      zip: "80202"
    },
  },
  {
    id: 9,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Pizza",
    description: "Hot, ready-to-eat pizzas in a variety of flavors.",
    machineType: "Pizza Vending Machine",
    location: {
      address: "888 Food Court",
      city: "Chicago",
      state: "IL",
      zip: "60601"
    },
  },
  {
    id: 10,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Books",
    description: "A library-style machine offering a selection of books and magazines.",
    machineType: "Book Vending Machine",
    location: {
      address: "777 Public Square",
      city: "Philadelphia",
      state: "PA",
      zip: "19107"
    },
  },
  {
    id: 11,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Flower+Machine",
    description: "Fresh bouquets and single-stem flowers for any occasion.",
    machineType: "Flower Vending Machine",
    location: {
      address: "321 Art Gallery Lane",
      city: "Paris",
      state: "TX",
      zip: "75460"
    },
  },
  {
    id: 12,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Personal+Care",
    description: "Offers toiletries, first-aid kits, and other personal care items.",
    machineType: "Personal Care Machine",
    location: {
      address: "444 Rest Stop",
      city: "Los Angeles",
      state: "CA",
      zip: "90001"
    },
  },
  {
    id: 13,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Umbrella+Vending",
    description: "Vends umbrellas for those unexpected rainy days.",
    machineType: "Umbrella Vending Machine",
    location: {
      address: "666 Downtown Rd",
      city: "London",
      state: "KY",
      zip: "40741"
    },
  },
  {
    id: 14,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Fishing+Bait",
    description: "Live fishing bait and lures for anglers.",
    machineType: "Fishing Bait Machine",
    location: {
      address: "987 Lakefront Rd",
      city: "Orlando",
      state: "FL",
      zip: "32801"
    },
  },
  {
    id: 15,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Lego+Machine",
    description: "Dispenses small Lego kits and mini-figures.",
    machineType: "Lego Vending Machine",
    location: {
      address: "123 Toy St",
      city: "Las Vegas",
      state: "NV",
      zip: "89101"
    },
  },
  {
    id: 16,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=T-Shirt+Vending",
    description: "Custom t-shirts available in various sizes and designs.",
    machineType: "T-Shirt Vending Machine",
    location: {
      address: "876 Convention Center Way",
      city: "Houston",
      state: "TX",
      zip: "77001"
    },
  },
  {
    id: 17,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Cotton+Candy",
    description: "Freshly made cotton candy in different colors and flavors.",
    machineType: "Cotton Candy Machine",
    location: {
      address: "135 Amusement Park Dr",
      city: "Dallas",
      state: "TX",
      zip: "75201"
    },
  },
  {
    id: 18,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Hot+Soup",
    description: "Provides a selection of hot soups for a quick, warm meal.",
    machineType: "Hot Soup Machine",
    location: {
      address: "246 Cold Weather Ave",
      city: "Minneapolis",
      state: "MN",
      zip: "55401"
    },
  },
  {
    id: 19,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Bicycle+Parts",
    description: "Vends bicycle tubes, patches, and other repair essentials.",
    machineType: "Bicycle Parts Vending Machine",
    location: {
      address: "192 Bike Path",
      city: "Portland",
      state: "OR",
      zip: "97201"
    },
  },
  {
    id: 20,
    photo: "https://placehold.co/400x300/EAEAEA/333333?text=Face+Masks",
    description: "Sells disposable and reusable face masks and sanitizers.",
    machineType: "Face Mask Machine",
    location: {
      address: "384 Hospital Rd",
      city: "Phoenix",
      state: "AZ",
      zip: "85001"
    },
  },
];

// Card component to display a single vending machine
const VendingMachineCard: React.FC<{ machine: VendingMachine }> = ({ machine }) => {
  return (
    <div className="bg-white shadow-lg rounded-xl overflow-hidden">
      <img
        src={machine.photo}
        className="w-full h-auto object-cover rounded-t-xl"
        alt={`Photo of a ${machine.machineType}`}
      />
      <div className="p-4">
        <h3 className="text-xl font-bold text-gray-800">{machine.machineType}</h3>
        <p className="text-sm text-gray-600 mt-2">{machine.description}</p>
      </div>
      <ul className="list-none p-0">
        <li className="border-t border-gray-200 px-4 py-2 text-gray-500 text-sm">
          <strong>Address:</strong><br />
          {machine.location.address}, {machine.location.city}, {machine.location.state} {machine.location.zip}
        </li>
      </ul>
    </div>
  );
};

// Gallery component to display all vending machines in a responsive grid
export const VendingMachineGallery_v01: React.FC = () => {
  return (
    <div className="p-5">
      <h1 className="text-center text-4xl font-extrabold text-gray-900 mb-8">Vending Machine Locations</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {vendingMachines.map((machine) => (
          <div key={machine.id} className="flex">
            <VendingMachineCard machine={machine} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default VendingMachineGallery_v01;
